<script lang="ts">
export default {
  name: 'KkSection',
}
</script>
<script setup lang="ts">
import { computed } from 'vue'
import { KkBox } from '../../../../components/base'
import { KkItem } from '../../../../domains/foodMenu'
import type {Section} from 'src/biz_spa/domains/foodMenu/types'

interface Props {
  section: Section
  selectedService: string
}
const props = defineProps<Props>()

const showDescription = computed<boolean>(() => props.selectedService != 'google')

</script>

<template>
  <KkBox :title="props.section.label" border>
    <template #header>
      <p v-if="showDescription" class="description">{{ props.section.description }}</p>
    </template>
    <template #content>
      <div v-for="(item, index) in props.section.items" :key="index">
        <KkItem
          :item="item"
          :selected-service="selectedService"
        />
      </div>
    </template>
  </KkBox>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.description {
  color: #9c9c9c;
}
.recommendBadge {
  background: #393a3e;
  border-radius: 12px;
  font-weight: bold;
  color: #FFF;
  font-size: 12px;
  padding: 4px 6px;
}
</style>
